module.exports = __webpack_public_path__ + "static/media/ZoomLogo.8d048abc.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ZoomLogo.PNG
// module id = 1364
// module chunks = 0